import { CarrierRole } from "../../types/carrier.types"

const generateCompaniesOptions = (_options, type = null) => {
  let options = _options
  if (type === CarrierRole.CARRIER) options = _options.filter(i => i.role === CarrierRole.CARRIER)
  if (type === CarrierRole.RETAILER) options = _options.filter(i => i.role === CarrierRole.RETAILER)

  return options
    .map(opt => ({
      value: opt["id"],
      label: `${opt.role === CarrierRole.RETAILER ? "👕" : "🚛"} ${opt.name}`,
      type: opt.role,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}

export default generateCompaniesOptions
